import { useCallback } from 'react';

import usePubSub from '../PubSub';

export default function usePayWallContainer() {
    const { publish } = usePubSub();

    return useCallback(data => publish('paywall_modal', data), [publish]);
}
